import {
  SITE_MODE_COOKIE,
  SITE_MODE_LANDING,
  isSiteMode,
  normalizeSiteMode,
  siteModeFromHost,
  type SiteMode,
} from '~/utils/siteMode'

const ONE_YEAR = 60 * 60 * 24 * 365

/**
 * Settings → Platform choice. A cookie (not localStorage) so SSR renders the
 * right bottom nav and the server bounce on `/` lands on the right page.
 */
export function useSiteMode() {
  const cookie = useCookie<string | null>(SITE_MODE_COOKIE, {
    maxAge: ONE_YEAR,
    sameSite: 'lax',
    path: '/',
  })
  const hostMode = siteModeFromHost(useRequestURL().host)
  const state = useState<SiteMode>('site-mode', () =>
    isSiteMode(cookie.value) ? cookie.value : normalizeSiteMode(hostMode))
  const chosen = useState<boolean>('site-mode-chosen', () =>
    isSiteMode(cookie.value) || hostMode !== null)

  const mode = computed(() => state.value)
  const landingPath = computed(() => SITE_MODE_LANDING[state.value])

  function setMode(next: SiteMode) {
    state.value = next
    chosen.value = true
    cookie.value = next
  }

  return { mode, chosen: computed(() => chosen.value), landingPath, setMode }
}
